import { useState, useEffect, useRef } from 'react';
import QRCode from 'qrcode';
import { BRAND } from '../config/brand';
import { qrCurrentToken, qrUrl } from '../lib/attendance';

// QR que cambia solo. Se muestra en una pantalla del local; el empleado lo escanea con la cámara del celular o desde la app.
export default function QrScreen({ compact = false, onBack }) {
  const [img, setImg] = useState('');
  const [left, setLeft] = useState(0);
  const [total, setTotal] = useState(60);
  const [err, setErr] = useState('');
  const timer = useRef(null);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const d = await qrCurrentToken();
        const dataUrl = await QRCode.toDataURL(qrUrl(d.token), { width: 640, margin: 1, errorCorrectionLevel: 'M', color: { dark: '#0f172a', light: '#ffffff' } });
        if (!alive) return;
        setImg(dataUrl); setErr(''); setTotal(d.rotate_seconds); setLeft(d.expires_in);
        timer.current = setTimeout(load, Math.max(3, d.expires_in - 1) * 1000);
      } catch (e) {
        if (!alive) return;
        setErr(e.message || 'No se pudo generar el QR');
        timer.current = setTimeout(load, 15000);
      }
    };
    load();
    return () => { alive = false; clearTimeout(timer.current); };
  }, []);

  useEffect(() => {
    const t = setInterval(() => setLeft((l) => Math.max(0, l - 1)), 1000);
    return () => clearInterval(t);
  }, []);

  const pct = total ? Math.max(0, Math.min(100, (left / total) * 100)) : 0;
  const card = (
    <div className={`bg-white rounded-3xl shadow-2xl text-center ${compact ? 'p-4' : 'p-6 sm:p-8'}`}>
      {err ? (
        <p className="text-sm text-red-600 px-4 py-10">{err}</p>
      ) : img ? (
        <img src={img} alt="Código QR para registrar entrada o salida" className={compact ? 'w-56 h-56 mx-auto' : 'w-72 h-72 sm:w-96 sm:h-96 mx-auto'} />
      ) : (
        <div className={`${compact ? 'w-56 h-56' : 'w-72 h-72'} mx-auto flex items-center justify-center text-sm text-gray-400`}>Generando…</div>
      )}
      <div className="mt-3 h-1.5 rounded-full bg-gray-100 overflow-hidden"><div className="h-full bg-sky-600 transition-all duration-1000 ease-linear" style={{ width: `${pct}%` }} /></div>
      <p className="text-[11px] text-gray-400 mt-1.5">Se renueva solo · {left}s</p>
    </div>
  );

  if (compact) return card;
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-5 py-8" style={{ background: 'linear-gradient(135deg,#0f172a 0%,#1e293b 100%)' }}>
      <div className="text-center mb-6">
        {BRAND.orgLogo && <img src={BRAND.orgLogo} alt="" className="h-14 mx-auto mb-3 rounded-2xl bg-white p-1" />}
        <h1 className="text-white text-2xl font-bold">{BRAND.orgName || BRAND.product}</h1>
        <p className="text-white/60 text-sm mt-1">Escaneá para registrar tu entrada o salida</p>
      </div>
      {card}
      <p className="text-white/50 text-xs mt-5 max-w-sm text-center">Abrí la cámara de tu celular y apuntá al código. Si es la primera vez, ingresá con tu usuario.</p>
      {onBack && <button onClick={onBack} className="mt-6 text-xs text-white/60 px-4 py-2 rounded-xl hover:bg-white/10">Volver</button>}
    </div>
  );
}
